import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MarkdownModule } from 'ngx-markdown';

export interface CoachResponseDialogData {
  coachResponse: string;
  timestamp: string;
  references?: any[];
  onReferenceClick?: (ref: any, event?: MouseEvent) => void;
}

@Component({
  selector: 'app-coach-response-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MarkdownModule],
  templateUrl: './coach-response-dialog.component.html',
  styleUrl: './coach-response-dialog.component.scss'
})
export class CoachResponseDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<CoachResponseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CoachResponseDialogData
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  openReference(ref: any, event?: MouseEvent): void {
    if (this.data.onReferenceClick) {
      this.data.onReferenceClick(ref, event);
    }
  }
}
